import React from 'react';

import { IIconProps, TIconType } from '../interface';

const PopsIcon: TIconType = (props?: IIconProps) => {
	return (
		<svg
			fill='none'
			height='24'
			viewBox='0 0 24 24'
			width='24'
		>
			<g clipPath='url(#clip0_41_2004)'>
				<circle
					cx='12'
					cy='12'
					fill={props?.color || 'currentColor'}
					r='12'
				/>
				<path
					d='M7 19C7 18.4477 7.44772 18 8 18H16C16.5523 18 17 18.4477 17 19V19.5H7V19Z'
					fill='white'
				/>
				<path
					clipRule='evenodd'
					d='M13 3.5C14.6569 3.5 16 4.84315 16 6.5V17H8V6.5C8 4.84315 9.34315 3.5 11 3.5H13ZM10 6.5V7.5H14V6.5C14 5.94772 13.5523 5.5 13 5.5H11C10.4477 5.5 10 5.94772 10 6.5ZM10 12.2536C10 12.3905 10.1031 12.4914 10.2254 12.4914H11.7778L10.9469 14.9554C10.8309 15.3156 11.1723 15.5101 11.3849 15.2219L13.9163 11.6917C13.9678 11.6268 14 11.5476 14 11.4755C14 11.3314 13.8969 11.2306 13.7681 11.2306H12.2222L13.0467 8.76657C13.1626 8.40634 12.8213 8.21181 12.6151 8.5L10.0773 12.0375C10.0258 12.1095 10 12.1816 10 12.2536Z'
					fill='white'
					fillRule='evenodd'
				/>
			</g>
			<defs>
				<clipPath id='clip0_41_2004'>
					<rect
						fill='white'
						height='24'
						width='24'
					/>
				</clipPath>
			</defs>
		</svg>
	);
};

export default PopsIcon;
